import styled from '@emotion/styled';

/**
 * Hidden on screen, read by screen readers, and kept by HTML-to-Markdown converters
 * (the /<page>.md build and AI agents), unlike `display: none`. Absolutely positioned:
 * keep it inside a positioned parent within any horizontal scroller, or RTL pages scroll
 * sideways. Render as another element with `as` (`as='p'`, `as='caption'`).
 */
const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;

export default VisuallyHidden;
